import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';

import { ToggleSidebar } from '../../state/main-view/main-view.actions';

@Component({
  selector: 'rtr-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  @Output() public logOut: EventEmitter<void> = new EventEmitter();

  private ngOnDestroy$: Subject<void> = new Subject();

  constructor(private store: Store) {}

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public closeSidebar(): void {
    this.store.dispatch(new ToggleSidebar(false));
  }
}
